// @ts-check
import React from "react";

/**
 * @typedef {import("primereact/menuitem/menuitem").MenuItem["command"]} MenuItemCommand
 */

export class MenuItemButton {
  /**
   * @param {string} id attribute, will be useful while writing automated test cases
   * @param {string} label
   * @param {string} materialIcon
   * @param {MenuItemCommand} command
   */
  constructor(id, label, materialIcon, command) {
    this.id = id;
    this.label = label;
    this.icon = <span className="material-icons">{materialIcon}</span>;
    this.command = command;
  }
}

/**
 * Create the menu item for Hide button 
 * @param {"Hidden" | "Active"} status
 * @param {MenuItemCommand} handleHideClick
 * @returns {MenuItemButton | undefined}
 */
export const getHideToggleMenuItem = (status, handleHideClick, /* handleUnhideClick = () => { } */) =>
  status !== "Hidden" ?
    new MenuItemButton(
      "hideMenuItem",
      "Hide", // status === "Hidden" ? "Unhide" : "Hide",
      "visibility_off", // "Hidden" ? "visibility" : "visibility_off",
      (commandArg) => {
        handleHideClick?.(commandArg);
        /* if (status !== "Hidden") {
          handleHideClick(commandArg);
        } else {
          handleUnhideClick(commandArg);
        } */
      },
    ) :
    undefined;
